<template>
  <div class="mediumbox">
    <FileSee ref='FileSee' :info='info'></FileSee>
    <drag-modal :visible="visible" :title='edit == 0 ? "查看" : (edit == 1 ? "新增" : "编辑")' width='520px' class="disform"
      @cancel='rest'>
      <div class="navbox">
        <div class="intopbtn" v-if='edit != 1'>
          <a-button icon="edit" type="primary" @click='edit = edit == 2 ? 0 : 2' size="small" style="height:34px">{{
            edit == 0 ? "修改" : "取消修改" }}</a-button>
          <a-popconfirm title="确认删除此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="del">
            <a-button icon="delete" type='danger' style="margin-left:10px;height:34px" size="small">删除</a-button>
          </a-popconfirm>
        </div>
      </div>
      <a-form-model ref="forms" :rules="rules" :model="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
        <a-form-model-item label="工具类型" prop="cate" :rules="{ required: true, message: '请选择工具类型', trigger: 'change' }">
          <a-select v-model="form.cate" placeholder="请选择" :disabled='edit == 0'>
            <a-radio :value="1">文档模板</a-radio>
            <a-radio :value="2">电子表格</a-radio>
            <a-radio :value="3">法条规定</a-radio>
            <a-radio :value="4">工作记录</a-radio>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="标题" prop="title" :rules="{ required: true, message: '请输入标题', trigger: 'blur' }">
          <a-input v-model="form.title" placeholder="请输入" :maxLength='30' style="width:272px;" class="ipt"
            :disabled='edit == 0'>
            <template #suffix>
              {{ form.title.length }}/30
            </template>
          </a-input>
        </a-form-model-item>
        <a-form-model-item label="内容" prop="content" :rules="{ required: true, message: '请输入内容', trigger: 'blur' }">
          <Ntxt :content='form.content' :max='1000' Hei='108px' :edit='edit == 0'
            @contentVal='(e) => { form.content = e }'>
          </Ntxt>
        </a-form-model-item>
        <a-form-model-item label="附件">
          <div class="fintbox">
            <div class="file">
              <div class="tit" :class='{ "log": edit == 0 }'>
                <span v-if='file.id' @click='seeFile(file)' style="cursor:pointer;"> {{ file.origin_name }}</span>
                <span v-else>请选择 </span>
                <a-icon type="close-circle" style="color:#f00;position: relative;" v-if='file.id && edit != 0'
                  @click='file.id = null' />
              </div>
              <div class="fbox" v-if='edit != 0'>
                选择文件
                <input type="file" @change="handlePreview($event)" id='files' />
              </div>
            </div>
            <a :href="file.url" target="_blank" :download="file.origin_name" v-if='file.id' style="padding-top:10px;">
              <a-icon type="cloud-download" class="icons"></a-icon>
            </a>

          </div>
          <b v-if='file.like > 0 && file.like < 3' :class='{ "err": file.like == 2 }'>{{ file.like == 1 ? '上传中' : "上传失败"
            }}</b>
        </a-form-model-item>

        <a-form-model-item v-if='edit != 0'>
          <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="confirm">
            <a-button type="primary" style="width: 133px;height: 32px;margin:0 0 0 100px;">
              确定
            </a-button>
          </a-popconfirm>
        </a-form-model-item>
      </a-form-model>
    </drag-modal>
    <div class="h2">
      <span>我的工具</span>
      <a-button type="link" icon="plus" @click='edit = 1; disType = 2; visible = true;' size="small"
        style="height:24px;">新增</a-button>
      <a-input-search type="text" placeholder="搜索" v-model='content' @search="init" class="ipt" />
    </div>
    <a-radio-group name="radioGroup" v-model='cate' class="checkbox" @change="init" size="small">
      <a-radio :value="1">文档模板</a-radio>
      <a-radio :value="2">电子表格</a-radio>
      <a-radio :value="3">法条规定</a-radio>
      <a-radio :value="4">工作记录</a-radio>
    </a-radio-group>
    <div class="list">
      <div class="scroll">
        <div class="li" v-for="i in list" :key="i.id" @click="see(i.id, 0)">
          <div class="tit">
            <Normap :tit="i.title"></Normap>
          </div>
          <div class="date">{{ i.update_time.slice(0, 10) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { todoAdd, todoInfo, todoUpdate, todoDel } from '@/server/api'
import $http from "superagent"
import { Tacitly } from '@/assets/js/Tacitly'
import FileSee from "@/components/filesee"
import { Filetype } from "@/assets/js/unit"
import Ntxt from '@/components/textarea/ntxt'
export default {
  name: 'Medium',
  components: { Ntxt, FileSee },
  data() {
    return {
      info: {},
      cate: 1,
      content: '',
      limit: 100,
      list: [],
      form: {
        title: '',
        content: '',
        cate: 1
      },
      visible: false,
      rules: {},
      file: {
        like: 0
      },
      openEdit: false,
      edit: 0,  //0查看 1新增 2編輯
    }
  },
  created() {
    this.init()
  },
  methods: {
    handlePreview(file) {         //上传图片
      this.$set(this.file, 'like', 0)
      let f = file.target.files[0],
        fileSize = file.size / 1024;
      // if (fileSize > 10240) {
      //   this.$message({
      //     type: "error",
      //     message: "上传的文件不能超过10mb"
      //   });
      //   return false;
      // }
      let fd = new FormData();
      fd.append("file", f);
      $http.post(Tacitly.Base_Port + "upload/file").set('Authorization', localStorage.getItem("t")).attach('file', f).on('progress', event => {
        this.$set(this.file, 'like', 1); //上传中
      }).then(res => {
        let data = res.body.data;
        if (res.body.code == "0000") {
          this.file = data
          this.$message.success({ content: '上传成功', key: 'updatable' });
          document.getElementById("files").value = ''
          this.$set(this.file, 'like', 3)   //上传成功
        } else {
          this.$message.error({ content: res.body.msg, key: 'updatable' });
          this.$set(this.file, 'like', 2)    //上传失败
          this.$set(this.file, 'origin_name', '')
          this.$set(this.file, 'id', '')
        }
      }).catch(e => {
        this.$message.error({ content: '上传失败', key: 'updatable' });
        this.$set(this.file, 'like', 2)
        this.$set(this.file, 'origin_name', '')
        this.$set(this.file, 'id', '')
      })
    },
    seeFile(i) {
      if (Filetype(i.url) == 4) {
        window.open("https://view.officeapps.live.com/op/view.aspx?src=" + i.url)
      } else {
        this.info = {
          type: Filetype(i.url),
          url: i.url,
          title: i.title || i.origin_name,
        }
        this.$refs.FileSee.visible = true;
      }
    },
    init() {
      this.$Ajax({
        url: 'tools/index',      //url 
        type: "get",
        data: { limit: this.limit, page: 1, cate: this.cate, content: this.content },
        success: (e) => {
          // console.log(e)
          this.list = e.list
        }
      })
    },
    rest() {
      this.form = {
        title: '',
        content: '',
        cate: 1
      };
      this.visible = false;
    },
    del() {
      todoDel({ id: this.form.id }).then(e => {
        this.form.content = '';
        this.$message.success('删除成功')
        this.rest()
        this.init()
      })
    },
    see(id) {
      todoInfo({ id: id }, 1).then(e => {
        this.form = {
          id: e.id,
          title: e.title,
          content: e.content,
          cate: e.cate
        }
        this.edit = 0
        if (e.file_id > 0) { this.file = e.file }
        else {
          this.file = {}
        }
        this.visible = true
      })
    },
    confirm() {
      let form = JSON.parse(JSON.stringify(this.form))
      let disform = {
        cate: form.cate,
        content: form.content,
        title: form.title,
        file_id: this.file.id
      }
      this.$refs.forms.validate(valid => {
        if (valid) {
          if (this.edit == 1) {
            todoAdd(disform, 2).then(e => {
              this.form.content = '';
              this.$message.success('新增成功')
              this.rest()
              this.init()
            })
          }
          else {
            disform.id = form.id
            todoUpdate(disform, 2).then(e => {
              this.form.content = '';
              this.$message.success('编辑成功')
              this.rest()
              this.init()
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      })
    },

  }
}
</script>
<style lang="less" scoped>
.disform {
  .fintbox {
    display: flex;
    align-items: center;
    position: relative;

    .icons {
      font-size: 20px;
      color: #2196f3;
      cursor: pointer;
      margin-left: 10px;
    }

    a {
      position: absolute;
      right: 34px;
    }
  }

  /deep/ .ant-form-item {
    margin-bottom: 14px;
  }

  /deep/ .ipt input {
    padding-right: 50px;
  }

  .file {
    width: 200px;
    height: 32px;
    border-radius: 4px;
    border: 1px solid #efefef;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    position: relative;
    margin-top: 4px;

    .tit {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 120px;
      overflow: hidden;
      height: 32px;
      margin-right: 2px;

      span {
        display: inline-block;
        width: 100px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        line-height: 32px;
      }
    }

    .log {
      width: 200px;

      span {
        width: 200px;
      }
    }

    .fbox {
      position: relative;
      color: #1d8bfe;
      white-space: nowrap;

      input {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        opacity: 0;
      }
    }
  }
}

.mediumbox {
  height: 280px;
  background: #FFF;
  margin-top: 10px;
  padding: 0 15px;

  .h2 {
    display: flex;
    align-items: center;
    height: 48px;
    white-space: nowrap;
    justify-content: space-between;
    border-bottom: 1px solid #EFEFEF;

    .ipt {
      // border:0 none;
      // line-height: 30px;
      // background:url('../../../assets/img/icon-search@2x.png') no-repeat right center;
      // background-size:14px 14px;
      // text-align: right;
      // padding-right: 20px;
      text-align: right;
      width: 200px;

      /deep/.ant-input {
        border: 0 none;
        box-shadow: none;
      }
    }
  }

  .checkbox {
    display: flex;
    padding: 6px 0;

    /deep/.ant-radio-wrapper {
      font-size: 12px;
      margin: 0;
    }

    /deep/ .ant-radio {
      transform: scale(0.8);

    }

    /deep/ span.ant-radio+* {
      padding: 0 4px;
    }

    @media screen and (max-width:1440px) {
      /deep/.ant-radio-wrapper {
        font-size: 10px;
        display: flex;
        align-items: center;
        margin: 0;
      }

      /deep/ .ant-radio {
        transform: scale(0.6);

      }

      /deep/ span.ant-radio+* {
        padding: 0 2px;
      }
    }
  }

  .list {
    height: 200px;
    overflow-y: auto;
    padding-right: 10px;

    .li {
      height: 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #EFEFEF;
      cursor: pointer;

      &:hover {
        color: #1d8bfe;
      }

      .tit {
        width: 60%;
        font-size: 14px;
        font-weight: 500;
      }

      .date {
        font-size: 12px;
        color: #9FA8B3;
      }

      &:nth-last-child(1) {
        border: 0 none;
      }
    }
  }
}
</style>